import TweenMax from 'TweenMax';
/**
 *
 * Hero Fader
 *
 */

( function ( $ ) {
	'use strict';

	$( '.js-fader' ).each( function( index, elem )  {

		var $faderItem      = $( elem ).find( '.js-fader__item' );
		var $itemArray      = $.makeArray( $faderItem );

		/**
		 * Creates array of hero itemArray
		 */
		function crossfade() {
			TweenMax.to( $itemArray[0], 1.75, { autoAlpha: 0 } );
			TweenMax.to( $itemArray[1], 1.75, { autoAlpha: 1 } );
			$itemArray.push( $itemArray.shift() );
		}

		if( 1 < $faderItem.length ) {

			TweenMax.set( $faderItem, { autoAlpha: 0 } );
			TweenMax.set( $itemArray[0], { autoAlpha: 1 } );

			setInterval( crossfade, 5000 );

		}
	} );

} )( jQuery );
